'use strict'

import VacancyApi from './../../api/vacancy.js'

const state = {
  data: null,
  loading: false,
  error: null
}

const getters = {
  getSFVacancyItemByVacancyId (state) {
    return (vacancyId) => {
      if (!Array.isArray(state.data) || !vacancyId) {
        return null
      }

      vacancyId = Number(vacancyId)

      const item = state.data.find((item) => {
        return item && Number(item.vacancy_id) === vacancyId
      })

      return item
    }
  }
}

const actions = {
  fetch ({commit, dispatch}) {
    commit('request')
    VacancyApi.fetchSFVacanciesList()
    .then(data => {
      commit('success', data.vacancy_list)
      dispatch('process/deloitteSF/vacancy/SFVacancy/init', null, {root: true})
    })
    .catch(err => commit('failure', err))
  },
  update({commit}, item) {
    commit('update', item)
  }
}

const mutations = {
  request (state) {
    state.loading = true
    state.error = null
  },

  failure (state, error) {
    state.loading = false
    state.error = error
  },

  success (state, data) {
    state.loading = false
    state.data = data
  },

  update(state, item) {
    const stateItem = state.data.find((el) => {
      return el.sap_vacancy_id === item.sap_vacancy_id
    })

    if (stateItem !== undefined) {
      Object.assign(stateItem, item)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}